/**
 * PassengerPicker — universal passenger selector (1–6 by default).
 *
 * Uses a NATIVE <select> so it works on every browser, every device, every OS.
 * Shadcn <Select> uses Radix popovers which can fail on some Android Chrome
 * versions (touch pointer-events captured by overlay). Native <select> opens
 * the OS-level picker which is always reliable.
 */
import { Label } from "@/components/ui/label";

export default function PassengerPicker({
  value,
  onChange,
  label = "Passengers",
  testid = "passenger-picker",
  min = 1,
  max = 6,
  className = "",
  showLabel = true,
}) {
  const opts = [];
  for (let n = min; n <= max; n++) opts.push(n);
  return (
    <div className={className}>
      {showLabel && (
        <Label className="text-[10px] uppercase tracking-widest text-zinc-400">{label}</Label>
      )}
      <select
        data-testid={testid}
        value={String(value)}
        onChange={(e) => onChange(parseInt(e.target.value, 10) || min)}
        className="w-full bg-zinc-950 border border-zinc-700 text-zinc-100 rounded-md h-11 px-3 mt-1 text-base font-semibold meter-display appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-400/40 focus:border-amber-400"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23f5b201' stroke-width='3'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 0.75rem center",
          backgroundSize: "0.75rem",
          paddingRight: "2.25rem",
        }}
      >
        {opts.map((n) => (
          <option key={n} value={n} className="bg-zinc-950 text-zinc-100">
            {n} {n === 1 ? "passenger" : "passengers"}
          </option>
        ))}
      </select>
    </div>
  );
}
